module.exports = __webpack_public_path__ + "static/img/Logotipo_Negativo_Vertical.e5bd9fb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/paginaoficial/Logotipo_Negativo_Vertical.png
// module id = fynP
// module chunks = 2